module.exports = __webpack_public_path__ + "vue/img/wx.cca2a60d.png";